import ListingCard from '@organisms/ListingCard';
import type { ReactElement } from 'react';

import {
  CardWrapper,
  ListingSubtitle,
  ListingTitle,
  ListingTitleWrapper,
} from '@/styles/GlobalStyle';

import { StyledContentWrapper } from './SearchPageView.styled';
import type { SearchPageViewProps } from './SearchPageView.types';

export const SearchPageView = ({
  searchTerm,
  articleList,
}: SearchPageViewProps): ReactElement => (
  <>
    <ListingTitleWrapper>
      <ListingSubtitle>🔎 Wyniki wyszukiwania</ListingSubtitle>
      <ListingTitle>{searchTerm && searchTerm.toUpperCase()}</ListingTitle>
    </ListingTitleWrapper>
    <StyledContentWrapper>
      {!articleList ? (
        <p>Ups!. Brak wyników wyszukiwania.</p>
      ) : (
        <>
          {articleList.map(article => (
            <CardWrapper key={article.title}>
              <ListingCard {...article} />
            </CardWrapper>
          ))}
        </>
      )}
    </StyledContentWrapper>
  </>
);
